import localforage from "localforage";

async function deriveKey(passphrase, salt) {
  const enc = new TextEncoder();
  const baseKey = await crypto.subtle.importKey(
    "raw",
    enc.encode(passphrase),
    { name: "PBKDF2" },
    false,
    ["deriveKey"]
  );
  return crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: enc.encode(salt),
      iterations: 250_000,
      hash: "SHA-256",
    },
    baseKey,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt", "decrypt"]
  );
}

async function encryptString(key, plaintext) {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const cipher = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    new TextEncoder().encode(plaintext)
  );
  const buf = new Uint8Array(iv.byteLength + cipher.byteLength);
  buf.set(iv, 0);
  buf.set(new Uint8Array(cipher), iv.byteLength);
  return btoa(String.fromCharCode(...buf));
}

async function decryptString(key, b64) {
  const data = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  const iv = data.slice(0, 12);
  const cipher = data.slice(12);
  const plain = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    key,
    cipher
  );
  return new TextDecoder().decode(plain);
}

export class SecureForage {
  /**
   * @param {string} storeName   Nombre del store (se usará como salt)
   * @param {string} passphrase  Contraseña maestra
   */
  constructor(storeName, passphrase) {
    this.store = localforage.createInstance({
      name: "RISKMANN-BY-SOFU",
      storeName,
    });
    this._ready = deriveKey(passphrase, storeName + "-salt").then((key) => {
      this.cryptoKey = key;
    });
  }

  async setItem(key, value) {
    await this._ready;
    const plaintext = JSON.stringify(value);
    const ciphertext = await encryptString(this.cryptoKey, plaintext);
    return this.store.setItem(key, ciphertext);
  }

  async getItem(key) {
    await this._ready;
    const ciphertext = await this.store.getItem(key);
    if (ciphertext == null) return null;
    const plaintext = await decryptString(this.cryptoKey, ciphertext);
    return JSON.parse(plaintext);
  }

  removeItem(key) {
    return this.store.removeItem(key);
  }

  clear() {
    return this.store.clear();
  }
}
